import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
`;

export const FormBox = styled.div`
  margin: auto;
  width: 90%;
  max-width: 350px;
  .input-phone-number {
    width: calc(100% - 10px);
    display: block;
    padding: 10px 5px;
    font-size: 20px;
    border: 1px solid black;
    border-radius: 5px;
  }
`;
